
import styled from "styled-components"
import lock from "../assets/images/lock_green.svg"
import { useEffect, useState } from "react"

const StyledGreenCard = styled.div`
    background-color: white;
    border: solid;
    border-radius: 10px;
    display: flex;
    justify-content: ${props => props.noresults ? "center" : "space-around"};
    align-items: center;
    flex-direction: column;
    padding: 40px 0;
    height: 160px;
    border: 3px solid #EEEEEE;
`;
const StyledWrapper = styled.div`
   padding: 5px;
`;
export function GameResultCard({ children, date, gameNumber, score, blocked, colorScore, colorMaxScore }) {
    const [convertedDate, setConvertedDate] = useState();
    const [time, setTime] = useState();
    useEffect(() => {

        var splitarray = new Array();
        splitarray = date.split(" ");
        setConvertedDate(splitarray[0])
        setTime(splitarray[1])
    }, [])
    return (
        <StyledWrapper>

            <StyledGreenCard>
                {blocked ? <img src={lock} width="50" />
                    :
                    <>
                        <div>Game {gameNumber}</div>

                        <div>
                            <span style={{ fontSize: 40, color: colorScore }}>{score}</span>
                            <span className="color-dark-orange" style={{ fontSize: 30, color: colorMaxScore }}>/6</span>
                        </div>
                        <div>
                            <div>{convertedDate}</div>

                        </div>

                    </>
                }

            </StyledGreenCard>

        </StyledWrapper>
    );
}